/**
 * Represents the steps involved in a workflow process.
 */
export enum WorkflowStep {
  DETAILS = 'Details',
  INSTRUCTIONS = 'Instructions',
  SECURITY = 'Security',
  ADMIN = 'Admin',
  SUMMARY = 'Summary',
}

/**
 * Represents the steps involved in an instruction process.
 */
export enum InstructionStep {
    DEFINITION = 'Definition',
    AI_CONFIG = 'AI Config',
    TYPES = 'Types',
    TEST = 'Test',
    SECURITY = 'Security',
    ADMIN = 'Admin',
    SUMMARY = 'Summary',
}

/**
 * Defines the types of automation available.
 * - WORKFLOW: Represents a workflow automation.
 * - INSTRUCTION: Represents an instruction automation.
 */
export enum AutomationType {
  WORKFLOW,
  INSTRUCTION
}

/**
 * Enumerates the possible actions that can be performed on an automation item.
 * - EDIT: Edit an existing automation item.
 * - CLONE: Clone an existing automation item.
 * - RUN: Run an automation item.
 * - CREATE: Create a new automation item.
 * - MY_ITEMS: View user's own automation items.
 * - MANAGE_ITEMS: Manage all automation items.
 */
export enum AutomationAction {
  EDIT,
  CLONE,
  RUN,
  CREATE,
  MY_ITEMS,
  MANAGE_ITEMS
}

export enum WorkflowExecutionStatusEnum {
  Waiting = 'waiting',
  UserInput = 'awaiting user input',
  InProgress = 'in progress',
  Cancelled = 'cancelled',
  Success = 'success',
  Failed = 'failed'
}

